import React, { useEffect, useState } from 'react';

import './scroll-top-button.scss';

export default function ScrollTopButton() {
  const [showButton, setShowButton] = useState(false);

  const scrollTop = (e: React.MouseEvent) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleScrollTop = () => {
    if (window.pageYOffset >= 82) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScrollTop);
    return () => {
      window.removeEventListener('scroll', handleScrollTop);
    };
  }, []);

  return (
    <a href="#" id="scroll-to-top" className={showButton ? 'active' : ''} onClick={scrollTop}>
      <i className="fa fa-angle-up"></i>
    </a>
  );
}
